import { settings } from "app";
import { ArrayField, Datagrid, ReferenceField, TextField } from "react-admin";
import EmployeeField from "server/components/Fields/EmployeeField";
import { erasmusRequests } from "api/erasmusApi";

const CommissionSection = () => {
  return (
    <ArrayField source="commissionMembers">
      <Datagrid
        bulkActionButtons={false}
        rowClick={false}
        sx={settings.style.detailsDatagrid}
      >
        <EmployeeField
          source="employeeId"
          label="Служител"
          sortable={false}
        />
        <ReferenceField
          source="role"
          label="Роля"
          reference={erasmusRequests.getCommitionRolesSelect()}
          link={false}
          sortable={false}
        >
          <TextField source="nameBg" />
        </ReferenceField>
      </Datagrid>
    </ArrayField>
  );
};

export default CommissionSection;
